var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isShow
    ? _c(
        "vuestic-sidebar",
        { attrs: { "v:hidden": "isOpen" } },
        [
          _c(
            "template",
            { slot: "menu" },
            [
              _c(
                "sidebar-link-group",
                [
                  _c("span", { attrs: { slot: "title" }, slot: "title" }, [
                    _c("span", {
                      staticClass:
                        "sidebar-menu-item-icon vuestic-icon vuestic-icon-forms",
                    }),
                    _c("span", [_vm._v(_vm._s(_vm.$t("menu.paymentOrder")))]),
                  ]),
                  _c(
                    "sidebar-link",
                    { attrs: { to: { name: "PaymentOrder" } } },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "temp",
                          attrs: { slot: "title" },
                          slot: "title",
                        },
                        [
                          _c("span", { staticClass: "circle" }),
                          _c("span", { staticStyle: { "font-size": "16px" } }, [
                            _vm._v(_vm._s(_vm.$t("menu.paymentOrderList"))),
                          ]),
                        ]
                      ),
                    ]
                  ),
                  _vm.permissions["Download"]
                    ? _c(
                        "sidebar-link",
                        { attrs: { to: { name: "PaymentOrderDownload" } } },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "circle-temp",
                              attrs: { slot: "title" },
                              slot: "title",
                            },
                            [
                              _c("span", { staticClass: "circle" }),
                              _c(
                                "span",
                                { staticStyle: { "font-size": "16px" } },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("menu.paymentOrderDownload"))
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm.permissions[_vm.pageName.recurring]
                ? _c("sidebar-link", { attrs: { to: { name: "Recurring" } } }, [
                    _c("span", { attrs: { slot: "title" }, slot: "title" }, [
                      _c("span", {
                        staticClass:
                          "sidebar-menu-item-icon vuestic-icon vuestic-icon-graph",
                      }),
                      _c("span", [_vm._v(_vm._s(_vm.$t("menu.recurrings")))]),
                    ]),
                  ])
                : _vm._e(),
              _vm.permissions[_vm.pageName.virtualAccount]
                ? _c(
                    "sidebar-link",
                    { attrs: { to: { name: "VirtualAccount" } } },
                    [
                      _c("span", { attrs: { slot: "title" }, slot: "title" }, [
                        _c("span", {
                          staticClass:
                            "sidebar-menu-item-icon vuestic-icon vuestic-icon-graph",
                        }),
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("menu.virtualAccount"))),
                        ]),
                      ]),
                    ]
                  )
                : _vm._e(),
              _vm.permissions[_vm.pageName.report]
                ? _c("sidebar-link", { attrs: { to: { name: "Report" } } }, [
                    _c("span", { attrs: { slot: "title" }, slot: "title" }, [
                      _c("span", {
                        staticClass:
                          "sidebar-menu-item-icon vuestic-icon vuestic-icon-graph",
                      }),
                      _c("span", [_vm._v(_vm._s(_vm.$t("menu.report")))]),
                    ]),
                  ])
                : _vm._e(),
              _vm.permissions[_vm.pageName.userManagement]
                ? _c(
                    "sidebar-link",
                    { attrs: { to: { name: "UserManagement" } } },
                    [
                      _c("span", { attrs: { slot: "title" }, slot: "title" }, [
                        _c("span", {
                          staticClass:
                            "sidebar-menu-item-icon vuestic-icon vuestic-icon-user",
                        }),
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("menu.userManagement"))),
                        ]),
                      ]),
                    ]
                  )
                : _vm._e(),
              _vm.permissions[_vm.pageName.appManagement]
                ? _c(
                    "sidebar-link",
                    { attrs: { to: { name: "AppManagement" } } },
                    [
                      _c("span", { attrs: { slot: "title" }, slot: "title" }, [
                        _c("span", {
                          staticClass:
                            "sidebar-menu-item-icon vuestic-icon vuestic-icon-ui-elements",
                        }),
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("menu.appManagement"))),
                        ]),
                      ]),
                    ]
                  )
                : _vm._e(),
              _vm.permissions[_vm.pageName.finance] && _vm.isNew
                ? _c(
                    "sidebar-link-group",
                    [
                      _c("span", { attrs: { slot: "title" }, slot: "title" }, [
                        _c("span", {
                          staticClass:
                            "sidebar-menu-item-icon vuestic-icon vuestic-icon-dollar",
                        }),
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("menu.FinancialManagement"))),
                        ]),
                      ]),
                      _vm.permissions[_vm.pageName.finance]
                        ? _c(
                            "sidebar-link",
                            { attrs: { to: { name: "FinancialManagement" } } },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "temp",
                                  attrs: { slot: "title" },
                                  slot: "title",
                                },
                                [
                                  _c("span", { staticClass: "circle" }),
                                  _c(
                                    "span",
                                    { staticStyle: { "font-size": "16px" } },
                                    [_vm._v(_vm._s(_vm.$t("menu.withdrawals")))]
                                  ),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm.permissions[_vm.pageName.finance]
                        ? _c(
                            "sidebar-link",
                            { attrs: { to: { name: "BankAccounts" } } },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "circle-temp",
                                  attrs: { slot: "title" },
                                  slot: "title",
                                },
                                [
                                  _c("span", { staticClass: "circle" }),
                                  _c(
                                    "span",
                                    { staticStyle: { "font-size": "16px" } },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("menu.bankAccounts"))
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.permissions[_vm.pageName.finance] && !_vm.isNew
                ? _c(
                    "sidebar-link",
                    { attrs: { to: { name: "FinancialManagement" } } },
                    [
                      _c("span", { attrs: { slot: "title" }, slot: "title" }, [
                        _c("span", {
                          staticClass:
                            "sidebar-menu-item-icon vuestic-icon vuestic-icon-dollar",
                        }),
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("menu.FinancialManagement"))),
                        ]),
                      ]),
                    ]
                  )
                : _vm._e(),
              _vm.permissions[_vm.pageName.merchantKyc]
                ? _c(
                    "sidebar-link",
                    { attrs: { to: { name: "MerchantKYC" } } },
                    [
                      _c("span", { attrs: { slot: "title" }, slot: "title" }, [
                        _c("span", {
                          staticClass:
                            "sidebar-menu-item-icon vuestic-icon vuestic-icon-files",
                        }),
                        _c("span", [_vm._v(_vm._s(_vm.$t("menu.kyc")))]),
                      ]),
                    ]
                  )
                : _vm._e(),
              _vm.permissions[_vm.pageName.wayBill]
                ? _c(
                    "sidebar-link-group",
                    [
                      _c("span", { attrs: { slot: "title" }, slot: "title" }, [
                        _c("span", {
                          staticClass:
                            "sidebar-menu-item-icon vuestic-icon vuestic-icon-forms",
                        }),
                        _c("span", [_vm._v(_vm._s(_vm.$t("menu.wayBill")))]),
                      ]),
                      _vm.permissions[_vm.pageName.wayBill]
                        ? _c(
                            "sidebar-link",
                            { attrs: { to: { name: "WayBillList" } } },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "temp",
                                  attrs: { slot: "title" },
                                  slot: "title",
                                },
                                [
                                  _c("span", { staticClass: "circle" }),
                                  _c(
                                    "span",
                                    { staticStyle: { "font-size": "16px" } },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("menu.paymentOrderList"))
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm.permissions[_vm.pageName.wayBill]
                        ? _c(
                            "sidebar-link",
                            { attrs: { to: { name: "BatchUpload" } } },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "circle-temp",
                                  attrs: { slot: "title" },
                                  slot: "title",
                                },
                                [
                                  _c("span", { staticClass: "circle" }),
                                  _c(
                                    "span",
                                    { staticStyle: { "font-size": "16px" } },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("menu.uploadHistory"))
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm.permissions[_vm.pageName.wayBill]
                        ? _c(
                            "sidebar-link",
                            { attrs: { to: { name: "DownloadLog" } } },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "circle-temp",
                                  attrs: { slot: "title" },
                                  slot: "title",
                                },
                                [
                                  _c("span", { staticClass: "circle" }),
                                  _c(
                                    "span",
                                    { staticStyle: { "font-size": "16px" } },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("menu.downloadHistory"))
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }